// @flow
import React from 'react'
import FormInput from '../shared/FormInput'
import FormLabel from '../shared/FormLabel'
import ErrorProfile from '../shared/ErrorProfile'

type Props = {
  showConfirmPassword: boolean,
  errors: Object,
  submit: Function
}

export default class PasswordChange extends React.Component<Props> {
  render () {
    return (
      <div>
        <h3 className='text-boulder lg-font-size'>
                    Change password
        </h3>
        {this.props.showConfirmPassword
          ? <div className='form__field'>
            <FormLabel htmlFor='user_current_password' text='Current password' />
            <FormInput
              errors={this.props.errors.current_password}
              type='password'
              id='current_password'
              name='user[current_password]'
            />
            <ErrorProfile errors={this.props.errors.current_password} />
          </div>
          : null
        }
        <div className='form__field m-48-left' >
          <FormLabel htmlFor='user_password' text='New password' />
          <FormInput
            errors={this.props.errors.password}
            type='password'
            id='user_password'
            name='user[password]'
          />
          <ErrorProfile errors={this.props.errors.password} />
        </div>
        <div className='form__field m-48-right'>
          <FormLabel htmlFor='user_password_confirmation' text='Confirm password' />
          <FormInput
            errors={this.props.errors.password_confirmation}
            type='password'
            id='user_password_confirmation'
            name='user[password_confirmation]'
          />
          <ErrorProfile errors={this.props.errors.password_confirmation} />
        </div>
        <div className='btn btn-normal btn-submit user-edit-btn mt-10' onClick={this.props.submit}>
                    Change
        </div>
      </div>
    )
  }
}

window.Components.PasswordChange = React.createFactory(PasswordChange)



// WEBPACK FOOTER //
// ./app/javascript/packs/components/userEdit/PasswordChange.js